import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ClosedCaptionsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ClosedCaptions",
    children: /*#__PURE__*/_jsx("path", {
      d: "M25.42 29H6.58C4.05 29 2 26.94 2 24.42V7.58C2 5.05 4.06 3 6.58 3h18.83c2.53 0 4.58 2.06 4.58 4.58v16.83c0 2.53-2.06 4.58-4.58 4.58ZM6.58 5C5.16 5 4 6.16 4 7.58v16.83c0 1.42 1.16 2.58 2.58 2.58h18.83c1.42 0 2.58-1.16 2.58-2.58V7.58c0-1.42-1.16-2.58-2.58-2.58zm4.91 16.4c-.76 0-1.46-.13-2.09-.39s-1.18-.63-1.64-1.12-.82-1.06-1.07-1.73c-.26-.67-.38-1.39-.38-2.19s.14-1.47.41-2.12.65-1.22 1.13-1.71q.72-.735 1.68-1.14c.64-.27 1.34-.41 2.09-.41.51 0 1.01.07 1.49.22s.92.36 1.32.62c.4.27.74.57 1.01.92l-1.25 1.37c-.26-.27-.53-.5-.8-.68-.28-.19-.56-.33-.86-.42-.3-.1-.6-.14-.91-.14-.46 0-.89.09-1.3.26q-.615.255-1.05.72c-.3.31-.53.68-.7 1.1-.17.43-.26.9-.26 1.42s.08 1.01.25 1.44.4.8.71 1.11c.3.31.67.55 1.1.71.43.17.89.25 1.4.25a3.513 3.513 0 0 0 1.82-.52c.26-.17.51-.36.73-.58l.96 1.55c-.24.27-.56.52-.96.74s-.85.39-1.34.52c-.5.12-.99.19-1.48.19Zm10.27 0c-.76 0-1.46-.13-2.09-.39s-1.18-.63-1.64-1.12-.82-1.06-1.07-1.73c-.26-.67-.38-1.39-.38-2.19s.14-1.47.41-2.12.65-1.22 1.13-1.71q.72-.735 1.68-1.14c.64-.27 1.34-.41 2.09-.41.51 0 1.01.07 1.49.22s.92.36 1.32.62c.4.27.74.57 1.01.92l-1.25 1.37c-.26-.27-.53-.5-.8-.68-.28-.19-.56-.33-.86-.42-.3-.1-.6-.14-.91-.14-.46 0-.89.09-1.3.26q-.615.255-1.05.72c-.3.31-.53.68-.7 1.1-.17.43-.26.9-.26 1.42s.08 1.01.25 1.44.4.8.71 1.11c.3.31.67.55 1.1.71.43.17.89.25 1.4.25a3.513 3.513 0 0 0 1.82-.52c.26-.17.51-.36.73-.58l.96 1.55c-.24.27-.56.52-.96.74s-.85.39-1.34.52c-.5.12-.99.19-1.48.19Z"
    })
  }));
};